import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const appleMessagesRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Apple Messages for Business" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { AppleMessagesCallback } = await import("./callback");
          return { Component: AppleMessagesCallback };
        },
      },
    ],
  },
];
